$(document).ready(function () {
  setTimeout(() => {
    const section = document.querySelector('.section-main-product');
    if (section) {
      const h = section.offsetHeight;
      section.style.minHeight = h + 'px';
      console.log('min-height set to', h);
    }
  }, 2500); // wait ~2.5 seconds
  // Unbind any previous handler, then bind once
  $(document)
    .off('click.sizeSwap', '.size_opt .option_text')
    .on('click.sizeSwap', '.size_opt .option_text', async function (e) {
      e.preventDefault();

      const el = this;
      const urlBase = el.dataset.productUrl;
      const variantId = el.getAttribute('var-id');
      const productId = el.getAttribute('data-product-id');
      if (!urlBase) return;

      // If this is already active (and same variant), skip
      if (el.classList.contains('active')) {
        const currentParams = new URLSearchParams(location.search);
        if (!variantId || currentParams.get('variant') === variantId) return;
      }

      // Loading guard
      if (el.classList.contains('is-loading')) return;
      el.classList.add('is-loading');

      const targetUrl = variantId ? `${urlBase}?variant=${encodeURIComponent(variantId)}` : urlBase;

      window.location.href = targetUrl;
    });

  // Re-run inline/external scripts for inserted HTML
  function reexecuteScripts(root) {
    const scripts = root.querySelectorAll('script');
    scripts.forEach(oldS => {
      const s = document.createElement('script');
      for (const { name, value } of Array.from(oldS.attributes)) s.setAttribute(name, value);
      if (oldS.src) {
        s.async = false;
        oldS.replaceWith(s);
      } else {
        s.textContent = oldS.textContent;
        oldS.replaceWith(s);
      }
    });
  }
});
